exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card[_v-7021c5b7]{padding:12px;border-bottom:1px solid #24272c}.card footer[_v-7021c5b7]{margin-top:10px}.card .avatar[_v-7021c5b7],.card .name[_v-7021c5b7]{vertical-align:middle}.card .avatar[_v-7021c5b7]{border-radius:2px}.card .name[_v-7021c5b7]{display:inline-block;margin:0 0 0 15px;font-size:16px}.card .search[_v-7021c5b7]{padding:0 10px;width:100%;font-size:12px;color:#fff;height:30px;line-height:30px;border:1px solid #3a3a3a;border-radius:4px;outline:none;background-color:#26292e}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-7021c5b7&scoped=true!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/card.vue
 ** module id = 308
 ** module chunks = 0
 **/